import { useParams } from "@tanstack/react-router";
import PrestationViewPage from "@features/creation/prestations/components/PrestationViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/creation/prestations/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.PRESTATIONS.VIEW),
  staticData: {
    title: "Detail prestation",
    permission: PERMISSIONS.CREATION.PRESTATIONS.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ViewPrestationPage,
});

function ViewPrestationPage() {
  const { id } = useParams({ from: "/_app/creation/prestations/$id/view" });
  return <PrestationViewPage id={id} />;
}
